
/**
 * 字串的長度範圍
 */
function lengthCondition() {
    return { "minLength": 6, "maxLength": 20 }
}


/**
 * 判斷是否為Json
 */
function isJson(str) {
    if (str == null) {
        return false;
    }
    try {
        let jsonStr = JSON.stringify(str)
        if (typeof JSON.parse(jsonStr) == "object") {
            return true;
        }
    }
    catch (e) { }
    return false;
}


/**
 * 判斷字串是否介於指定的範圍，回傳boolean
 */
function isLengthMeet(str) {
    let meetLength = lengthCondition();
    if (str.length >= meetLength.minLength && str.length <= meetLength.maxLength) {
        return true;
    }
    return false;
}


/**
 * 字串中只要有字元在UTF-8超過3 Bytes，回傳true
 */
function isStringHaveUTF8MoreThen3BytesChar(str) {
    for (let i = 0; i < str.length; i++) {
        let codePoint = str.charCodeAt(i);
        if(0xD800 <= codePoint && codePoint <= 0xDBFF) { // 如果Unicode符合0xD800~0xDBFF，表示是一個UTF-16的high surrogate
            i++;
            let lowSurrogate = str.charCodeAt(i);
            if(0xDC00 <= lowSurrogate && lowSurrogate <= 0xDFFF) { // 如果high surrogate下一個Unicode符合0xDC00~0xDFFF，則是一個UTF-16的low surrogate
                // 在此已經確定字串中有字元的Unicode超過0xFFFF
                return true;
            }
        }
    }
    return false;
}


/**
 * 判斷字串是否介於指定的範圍
 */
function validLength(str, errorMsgArr = { "req": "Please insert account name", "maxLen": "Invalid account length", "minLen": "Invalid account length", }) {
    let meetLength = lengthCondition();
    let errorMsg = "";
    if (str === null || str == "") {
        errorMsg = errorMsgArr.req;
    }
    if (str.length > 0) {
        if (str.length < meetLength.minLength) {
            errorMsg = errorMsgArr.minLen;
        }
        else if (str.length > meetLength.maxLength) {
            errorMsg = errorMsgArr.maxLen;
        }
    }
    return errorMsg;
}


/**
 * 判斷字串為英數字
 */
function validEngNumOnly(str, errorMsgArr = { 'engNumOnly': "Illegal character detected." }) {
    let errorMsg = "";
    if (!(/^[A-Za-z0-9]+$/.test(str))) {
        errorMsg = errorMsgArr.engNumOnly;
    }
    return errorMsg;
}


/**
 * 判斷國碼、手機號碼
 */
function vaildPhone(countryCode, phone, errorMsgArr = { "countryCodeFormat": "Contry code must be 4 digits and contain \"+\"", "countryCodePlus": "Country code must begin with \"+\"", "countryCodeReq": "Please fill in country code", "phoneNum": "Phone number must be numerical", "phoneReq": "Please fill in mobile number", "phoneTwPhoneFormat": "Taiwanese phone number must be 9 digits", "phoneTwPhoneFirstDigitalNine": "Phone number registered in Taiwan must start with a 9.", }) {
    // 國碼 - 未填寫國碼
    if (countryCode == "") {
        return errorMsgArr.countryCodeReq;
    }
    // 國碼 - 開頭需為"+"
    if (!(/^\+/.test(countryCode))) {
        return errorMsgArr.countryCodePlus;
    }
    // 國碼 - 包含加號與數字最多4位數
    if (!(/^\+[0-9]{1,3}$/.test(countryCode))) {
        return errorMsgArr.countryCodeFormat;
    }

    // 手機 - 未填寫手機號碼
    if (phone == "") {
        return errorMsgArr.phoneReq;
    }
    // 手機 - 手機號碼限制1~20碼且純數字
    if (!(/^[0-9]{1,20}$/.test(phone))) {
        return errorMsgArr.phoneNum;
    }
    // 手機 - 如果國碼是+886(台灣)
    if (countryCode == "+886") {
        if (!(/^9/.test(phone))) { // 手機開頭如果是非9開頭(台灣國際碼手機號碼開頭不為0)
            return errorMsgArr.phoneTwPhoneFirstDigitalNine;
        }
        else if (!(/^[0-9]{9}$/.test(phone))) { // 台灣國際手機號碼如果不為9碼
            return errorMsgArr.phoneTwPhoneFormat
        }
    }
    return "";
}


/**
 * 判斷email字串不為空，且符合格式
 */
function validEmail(emailString, errorMsgArr = { 'req': "Please enter email", "format": "Invalid Email format" }) {
    let reg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    let errorMsg = "";
    if (emailString === null || emailString == "") {
        errorMsg = errorMsgArr.req;
    }
    else if (!(reg.test(emailString))) {
        errorMsg = errorMsgArr.format;
    }
    return errorMsg;
}


/**
 * 判斷發票的手機條碼不為空，且符合格式
 */
function validInvoicePhoneBarcode(phoneBarcode, errorMsgObj = { 'req': "請輸入手機條碼", "format": "手機條碼格式錯誤" }) {
    let errorMsg = "";
    let phoneBarcodeRegExp = new RegExp("^/[0-9A-Z\+.-]{7}$");
    if (phoneBarcode == null || phoneBarcode.trim() == "") {
        errorMsg = errorMsgObj.req;
    }
    else if (phoneBarcodeRegExp.test(phoneBarcode) == false) {
        errorMsg = errorMsgObj.format;
    }
    return errorMsg;
}


/**
 * 判斷發票的自然人憑證不為空，且符合格式
 */
function validInvoiceCertificate(certificate, errorMsgObj = { 'req': "請輸入自然人憑證", "format": "自然人憑證格式錯誤" }) {
    let errorMsg = "";
    let certificateRegExp = new RegExp("^[A-Z]{2}[0-9]{14}$");
    if (certificate == null || certificate.trim() == "") {
        errorMsg = errorMsgObj.req;
    }
    else if (certificateRegExp.test(certificate) == false) {
        errorMsg = errorMsgObj.format;
    }
    return errorMsg;
}


/**
 * 判斷發票的10碼手機號碼不為空，且符合格式
 */
function validInvoice10DigisPhone(phone, errorMsgObj = { 'req': "請輸入手機號碼", "format": "手機號碼格式錯誤" }) {
    let errorMsg = "";
    let phoneRegExp = new RegExp("^[0-9]{10}$");
    if (phone == null || phone.trim() == "") {
        errorMsg = errorMsgObj.req;
    }
    else if (phoneRegExp.test(phone) == false) {
        errorMsg = errorMsgObj.format;
    }
    return errorMsg;
}


/**
 * 判斷發票的統一編號不為空，且符合格式
 */
function validInvoiceGUINumber(GUINumber, errorMsgObj = { 'req': "請輸入統一編號", "format": "統一編號格式錯誤" }) {
    let errorMsg = "";
    let GUINumberRegExp = new RegExp("^[0-9]{8}$");
    if (GUINumber == null || GUINumber.trim() == "") {
        errorMsg = errorMsgObj.req;
    }
    else if (GUINumberRegExp.test(GUINumber) == false) {
        errorMsg = errorMsgObj.format;
    }
    return errorMsg;
}


/**
 * 判斷發票的統一編號不為空，且符合格式
 */
function validInvoiceloveCode(loveCode, errorMsgObj = { 'req': "請輸入愛心碼", "format": "愛心碼格式錯誤" }) {
    let errorMsg = "";
    let loveCodeRegExp = new RegExp("^[0-9]{3,7}$");

    if (loveCode == null || loveCode.trim() == "") {
        errorMsg = errorMsgObj.req;
    }
    else if (loveCodeRegExp.test(loveCode) == false) {
        errorMsg = errorMsgObj.format;
    }
    return errorMsg;
}


export default {
    isJson,
    isLengthMeet,
    isStringHaveUTF8MoreThen3BytesChar,
    validLength,
    validEngNumOnly,
    validEmail,
    vaildPhone,
    validInvoicePhoneBarcode,
    validInvoiceCertificate,
    validInvoice10DigisPhone,
    validInvoiceGUINumber,
    validInvoiceloveCode
}